import {
  createAsyncActionTypes,
  createActionTypes,
} from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes([
  'FETCH_NOTES',
  'SEARCH_NOTES',
  'CREATE_NOTE',
  'UPDATE_NOTE',
  'DELETE_NOTE',
]);

const actions = createActionTypes([
  'SET_NOTES_CACHE',
  'SET_NOTES_CACHE_INITIALIZED',
  'RESET_SET_NOTES_STATE',
  'SET_NOTES_IS_SEARCHING',
]);

export default {
  ...asyncActions,
  ...actions,
};
